"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const styled_components_1 = __importDefault(require("styled-components"));
const libs_context_modals_1 = require("@hotelplan/libs.context.modals");
const libs_hooks_dom_1 = require("@hotelplan/libs.hooks-dom");
const UIOverlay = styled_components_1.default.div `
  position: ${({ position }) => position};
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: transparent;
  pointer-events: none;
  z-index: 999;

  & > * {
    pointer-events: auto;
  }
`;
const ModalOverlay = props => {
    const { children, position = 'fixed' } = props, divProps = __rest(props, ["children", "position"]);
    const modalElement = (0, libs_context_modals_1.useModalContext)();
    const { height, offsetTop } = (0, libs_hooks_dom_1.useViewportSize)();
    return modalElement
        ? react_dom_1.default.createPortal(react_1.default.createElement(UIOverlay, Object.assign({ position: position }, divProps, { style: { maxHeight: `${height + offsetTop}px` }, "data-id": "modal-overlay" }), children), modalElement)
        : null;
};
exports.default = ModalOverlay;
//# sourceMappingURL=ModalOverlay.js.map